// extracted by mini-css-extract-plugin
export default {"slider":"CourseSlider_slider__aBTOC"};